import { useSelector } from 'react-redux';

import { useFeatureToggle } from '@flopflip/react-redux';

import { COMPOSED_CLAIMS } from 'constants/composedClaims';
import { FeatureFlag } from 'constants/featureFlags';

import { selectIsClaimAllowed } from 'store/auth/selectors';

/**
 * Returns true when the notification-center tab should be visible in the bottom nav.
 * Mirrors the gating logic used by `PushNotificationBell` in the desktop `Header`:
 * both the claim AND the feature flag must be active.
 *
 * @returns {boolean}
 */
const useNotificationsTabEnabled = () => {
  const isClaimAllowed = useSelector(
    selectIsClaimAllowed(COMPOSED_CLAIMS.NOTIFICATION_CENTER_ACCESS),
  );
  const isFeatureEnabled = useFeatureToggle(FeatureFlag.EnableNotificationCenter);

  return isClaimAllowed && isFeatureEnabled;
};

export default useNotificationsTabEnabled;
